import { BottomNavigation } from "@/pages/home/bottom-navigation"
import { Tabs } from "@/pages/home/tabs/tabs"

import { Layout } from "@/components/layout"
import { LocationPopup } from "@/components/location-popup"

const HomePage: React.FunctionComponent = () => {
  return (
    <Layout className="bg-white" name="home">
      <Tabs />
      <div className="absolute inset-x-0 bottom-0 flex">
        <BottomNavigation />
      </div>
      <LocationPopup />
    </Layout>
  )
}

export { HomePage }
